import { mutatorAction } from 'satcheljs';
import { getNotificationSettingsStore } from '../store/store';
import { DesktopNotificationSetting, NotificationSettingValue } from '../utils/Constants';
import { ObservableMap } from 'mobx';

export const changeDesktopNotificationSetting = mutatorAction(
    'SET_DESKTOP_NOTIFICATION_SETTING',
    (desktopSettingKey: DesktopNotificationSetting, value: NotificationSettingValue) => {
        let store = getNotificationSettingsStore();
        if (!store.desktopNotificationSettingsDirty) {
            // shallow copy the current settings into a backup copy which is used to reset settings if user discards
            store.backupSettings = new ObservableMap(store.settings);
        }
        store.settings.set(desktopSettingKey, value);
        store.desktopNotificationSettingsDirty = true;
    }
);
